import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { config } from 'environment';
import { uuid } from 'jakapa-utilities-lite';
import { Observable } from 'rxjs';

export interface LeaderChallengeStatsAPIResponse {
	organizations: Array<{
		uuid: uuid;
		completed: number;
		streak: number;
		positive: number;
		goal: number;
	}>;
	users: Array<{
		uuid: uuid;
		genericName: string;
		groupUUID: uuid;
		organizationUUID: uuid;
		completed: number;
		streak: number;
		positive: number;
		goal: number;
		abstractCompleted: number;
		adventureCompleted: number;
		brainCompleted: number;
		decisionCompleted: number;
		goalCompleted: number;
		journalCompleted: number;
		messageCompleted: number;
		stressCompleted: number;
		wwydCompleted: number;
	}>;
}

@Injectable({
	providedIn: 'root',
})
export class LeaderSkillBuilderService {
	constructor(private http: HttpClient) {}

	getStats(): Observable<LeaderChallengeStatsAPIResponse> {
		return this.http.get<LeaderChallengeStatsAPIResponse>(
			`${config.apiBase}leader/challenge/stats`,
		);
	}
}
